import * as React from 'react';
import { IPaymentDetails } from '../CustomTypes';
import {
  classNames,
  BorderColor,
  BorderWidth,
  BorderStyle,
  Padding,
  Display,
  JustifyContent,
  Margin,
  RadioButton,
  AlignItems
} from '@snoam/pinata';

interface IPaymentMethodState {
  showButton: boolean;
}

interface IPaymentMethodProps {
  paymentDetails: IPaymentDetails;
  secondRow?: any;
  textElements?: any;
  image?: any;
  selectedPaymentMethodId: number;
  onKeyDown?: (e: any) => void;
}

const styleClass = {
  container: classNames(
    BorderColor.BORDER_NEUTRAL_2,
    BorderWidth.BORDER_B_1,
    BorderStyle.BORDER_SOLID,
    Padding.PR_3,
  ),
  radioButton: classNames(Margin.MR_4, Margin.MT_1),
  text: classNames(
    Display.FLEX,
    JustifyContent.JUSTIFY_BETWEEN,
    AlignItems.ITEMS_CENTER,
    Padding.PT_6,
    Padding.PB_4,
  )
};

class PaymentMethod extends React.Component<
  IPaymentMethodProps,
  IPaymentMethodState
> {

  public static displayName = "PaymentMethod";

  constructor(props: IPaymentMethodProps) {
    super(props);
    this.state = {
      showButton: false
    };
  }

  public render() {
    const {
      paymentDetails,
      selectedPaymentMethodId,
      secondRow,
      textElements,
      image
    } = this.props;
    const selected = selectedPaymentMethodId === paymentDetails.id;

    return (
      <div key={paymentDetails.id} className={styleClass.container}>
        <label htmlFor={`payment-method-${paymentDetails.id}`}>
          <div className={styleClass.text}>
            <div
              data-testing={
                paymentDetails.type === 'STREX' && 'strex-payment-method'
              }
            >
              <RadioButton
                id={`payment-method-${paymentDetails.id}`}
                value={'' + paymentDetails.id}
                onKeyDown={this.props.onKeyDown}
              />
            </div>
            {textElements && textElements}
            {image && <div className={Margin.ML_AUTO}>{image}</div>}
          </div>
        </label>

        {selected && secondRow}
      </div>
    );
  }
}

export default PaymentMethod;
